import {Component} from '@angular/core';

@Component({
    selector: 'registration-result',  
    templateUrl:'./registration-result.component.html'
    
})

export class RegistrationResultComponent {    
}